import { initializeDevices } from './../../common/device/initialize-devices';
import { updateTouchPointConfiguration } from '../../touchpoint/business-logic/touchpoint-configuration';
import { getPLUmenu } from 'src/home-page/business-logic/get-plu-menu';
import { startTouchpoint } from 'src/touchpoint/business-logic/start-touchpoint';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';

export const getConfiguration = async () => {
  await updateTouchPointConfiguration();
  await Promise.all([initializeDevices(true), getPLUmenu()]);
};

export const emeraldStartupSequence = async () => {
  const span = createSpan('xlr-configuration-startup-sequence');
  await getConfiguration();
  endSpan(span);
};

export const r10StartupSequence = async () => {
  await startTouchpoint();
};
